export var ActionRequiredType;
(function (ActionRequiredType) {
    ActionRequiredType["CloudResourceActionRequiredUnspecified"] = "CLOUD_RESOURCE_ACTION_REQUIRED_UNSPECIFIED";
    ActionRequiredType["AzureSqlVmInvalidConfiguration"] = "AZURE_SQL_VM_INVALID_CONFIGURATION";
    ActionRequiredType["DynamoDbInvalidStreamViewType"] = "DYNAMO_DB_INVALID_STREAM_VIEW_TYPE";
    ActionRequiredType["DynamoDbInsufficientRcus"] = "DYNAMO_DB_INSUFFICIENT_RCUS";
    ActionRequiredType["RdsDatabaseStopped"] = "RDS_DATABASE_STOPPED";
    ActionRequiredType["BigqueryChangeHistoryDisabled"] = "BIGQUERY_CHANGE_HISTORY_DISABLED";
    ActionRequiredType["ObjectStoreInventoryRequired"] = "OBJECT_STORE_INVENTORY_REQUIRED";
    ActionRequiredType["CloudSqlDatabaseStopped"] = "CLOUD_SQL_DATABASE_STOPPED";
    ActionRequiredType["RdsGlobalDbSecondaryCluster"] = "RDS_GLOBAL_DB_SECONDARY_CLUSTER";
    ActionRequiredType["SapHanaBackupNotConfigured"] = "SAP_HANA_BACKUP_NOT_CONFIGURED";
    ActionRequiredType["KeyspacesCdcNotEnabled"] = "KEYSPACES_CDC_NOT_ENABLED";
    ActionRequiredType["AwsNativePitrPermissionsMissing"] = "AWS_NATIVE_PITR_PERMISSIONS_MISSING";
    ActionRequiredType["RdsManagedByExternalBackupPlan"] = "RDS_MANAGED_BY_EXTERNAL_BACKUP_PLAN";
    ActionRequiredType["SapHanaAgentApplicationNotOnboarded"] = "SAP_HANA_AGENT_APPLICATION_NOT_ONBOARDED";
    ActionRequiredType["KeyspacesInsufficientRcus"] = "KEYSPACES_INSUFFICIENT_RCUS";
    ActionRequiredType["AzureFilesStorageAccountInExternalVault"] = "AZURE_FILES_STORAGE_ACCOUNT_IN_EXTERNAL_VAULT";
    ActionRequiredType["AzureFilesBackupPermissionMissing"] = "AZURE_FILES_BACKUP_PERMISSION_MISSING";
})(ActionRequiredType || (ActionRequiredType = {}));
